import { ref, computed, h, defineComponent } from 'vue';
import { ElUpload, ElDatePicker } from 'element-plus';
import SvgIcon from '@/components/SvgIcon';
import EditPopup from '../components/EditPopup';
import { dayjs, vueCreateAppInit } from '@/utils/js/initVariable';
import {
  getCameraByRegion, uploadShootingLocationVideo, getAuthLink,
} from '@/api/UserWorkspaceDataApi';

const videoTimeProp = 'videoFileTime';
const videoTimeChangeProp = 'videoFileChangeTime';

/**
 * 摄像头视频上传/Leaflet marker 管理
 * @param {Object} props - 组件 props
 * @param {Object} editTarget - reactive 编辑目标
 * @param {Object} filmLayerGroup - 视频图层组
 * @param {Ref} loadProp - loading 属性名
 */
export function useFilmUpload(props, editTarget, filmLayerGroup, loadProp) {

  const filmUploadComGet = (target) => {
    return defineComponent({
      setup() {
        const videoUrl = ref(undefined),
          videoFileTime = ref(new Date()),
          loading = ref(false);
        if (target[videoTimeProp]) {
          videoFileTime.value = new Date(target[videoTimeProp]);
          target[videoTimeChangeProp] = target[videoTimeProp];
        }
        if (target['videoFileName']) {
          loading.value = true;
          getAuthLink(target['videoFileName']).then(res => {
            if (res.data.code === 1004) {
              videoUrl.value = res.data.data;
            }
            loading.value = false;
          }).catch(err => {
            loading.value = false;
            console.log(err);
          });
        }
        const slotContent = computed(() => {
          return videoUrl.value
            ? () => [
              h('video', {
                controls: false,
                style: { width: '200px', height: '120px' },
                src: videoUrl.value,
                autoplay: true,
                loop: true,
              }),
              h(ElDatePicker, {
                modelValue: videoFileTime.value,
                'onUpdate:modelValue': (val) => {
                  videoFileTime.value = val;
                  target[videoTimeChangeProp] = val;
                },
                size: 'small',
              })
            ]
            : () => h(SvgIcon, {
              iconName: loading.value ? 'loading' : 'plus-box',
              fillColor: 'rgb(81, 177, 217)',
            })
        });

        return () => h(ElUpload, {
          showFileList: false,
          autoUpload: false,
          action: '',
          accept: '.mp4',
          disabled: loading.value,
          class: 'popup-film-upload',
          onChange: (file, fileList) => {
            loading.value = true;
            uploadShootingLocationVideo({
              file: file.raw,
            }).then(res => {
              if (res.data.code === 1004) {
                if (!editTarget.shootingLocationList.includes(target)) {
                  editTarget.shootingLocationList.push(target);
                }
                target['videoFileName'] = res.data.data['imageName'];
                videoUrl.value = res.data.data['data'];
              }
              loading.value = false;
            }).catch(err => {
              loading.value = false;
              console.log(err);
            });
          },
        }, {
          default: slotContent.value,
        })
      }
    })
  }

  const filmIconUrl = require('@/assets/icon/marker/film.png');

  const filmDataInit = (list) => {
    list.forEach(item => {
      const filmUploadComApp = vueCreateAppInit(
        defineComponent({
          setup() {
            return () => h(EditPopup, {
              title: '上传视频',
              controls: [
                {
                  iconName: 'check-box', fill: 'rgb(102, 203, 118)',
                  onClick: () => {
                    if (item[videoTimeChangeProp]) {
                      item[videoTimeProp] = dayjs(item[videoTimeChangeProp]).format('YYYY-MM-DD HH:mm:ss');
                    }
                    if (!marker) return;
                    marker.togglePopup();
                  }
                },
              ],
              target: props.target,
              style: {
                minWidth: '180px',
                height: 'auto',
              }
            }, {
              default: () => h(filmUploadComGet(item))
            })
          }
        })
      );
      const popupopenFn = () => {
        let fn = (popupopen) => {
          const popup = popupopen.popup,
            popupEl = popup.getElement();
          if (popupEl) {
            filmUploadComApp.mount(popupEl)
          }
        }
        return (popupopen) => {
          fn(popupopen);
          fn = () => { }
        }
      }
      const iconSize = [18, 18];
      const marker = L.marker(item, {
        icon: L.icon({
          iconUrl: filmIconUrl,
          iconSize,
          iconAnchor: iconSize.map(e => e / 2),
        })
      }).on({
        popupopen: popupopenFn(),
      })
      if (item.name) {
        marker.bindTooltip(item.name, {
          sticky: true,
          className: "leaflet-tooltip-message",
          direction: 'top',
        })
      }
      marker.bindPopup(undefined, {
        closeButton: false,
        autoClose: false,
        offset: [0, 5],
        direction: 'top',
        className: 'leaflet-popup-transparent',
      })

      marker.addTo(filmLayerGroup);
    })
  }

  const filmDataRequest = (btn) => {
    btn[loadProp.value] = true;
    const bounds = props.layer.getBounds(),
      bbox = [
        bounds.getNorthWest().lng,
        bounds.getNorthWest().lat,
        bounds.getSouthEast().lng,
        bounds.getSouthEast().lat,
      ],
      geojson = props.layer.toGeoJSON(),
      geometry = JSON.stringify(geojson['geometry'] ? geojson['geometry'] : geojson);
    getCameraByRegion({ bbox, geometry }).then(res => {
      if (res.data.code === 1004) {
        const flagList = editTarget['shootingLocationList'].map(e => {
          return e.flag;
        })
        filmDataInit(
          (res.data.dataList || []).filter(e => {
            return !flagList.includes(e.flag);
          })
        );
        btn.onClick = () => { };
      }
      btn[loadProp.value] = false;
    }).catch(err => {
      btn[loadProp.value] = false;
      console.log(err);
    });
  }

  return { filmDataInit, filmDataRequest };
}
